import register from '../register.js';
import debounce from './util/debounce.js';

register( 'cat-pong', () => {

  let rAF = window.requestAnimationFrame;

  let canvas = document.getElementById('pong-canvas');
  let ctx = canvas.getContext('2d');
  let W;
  let H;
  let cat = {};
  let paddles = [];
  let mouse = {};
  let started = false;
  let bgColor = 'transparent';
  let foregroundColor = '#f8e534';
  let happyCat = document.getElementById('cat-emoji');
  let sadCat = document.getElementById('cat-emoji-sad');
  let catImg = happyCat;
  let timeout;
  let containerOffset = getTopOffset( canvas );

  function isMobile() {
    return window.innerWidth <= 800;
  }

  function getTopOffset( el ) {
    let node = el;
    let top  = 0;

    while ( node ) {
      top += node.offsetTop;
      node = node.offsetParent;
    }

    return top;
  }

  function updateCoords() {
    containerOffset = getTopOffset( canvas );
  }

  function calcCanvas() {
    let parent = document.querySelector('.cat-pong');
    let parentHeight = parent.offsetHeight;
    canvas.setAttribute( 'width', window.innerWidth );
    canvas.setAttribute( 'height', parentHeight );
    W = canvas.width;
    H = canvas.height;

    // retina canvas
    let ratio = window.devicePixelRatio || 1;
    if ( ratio !== 1 ) {
      canvas.style.width = canvas.width + 'px';
      canvas.style.height = canvas.height + 'px';
      canvas.width *= ratio;
      canvas.height *= ratio;
      ctx.scale( ratio, ratio );
    }
  }

  function clearCanvas() {
    ctx.clearRect( 0, 0, W, H );
  }

  function paintCanvas() {
    ctx.fillStyle = bgColor;
    ctx.fillRect( 0, 0, W, H );
  }

  function resetPaddles() {
    paddles = [];
    initPaddles();
  }

  class Paddle {
    constructor( pos ) {
      // height and width
      this.h = 180;
      this.w = 20;

      // position
      this.x = pos === 'left' ? 0 : W - this.w;
      this.y = H / 2 - this.h / 2;
    }
  }

  // push 2 new paddles into paddles array
  function initPaddles() {
    paddles.push( new Paddle('left') );
    paddles.push( new Paddle('right') );
  }

  function range( min, max ) {
    return Math.random() * ( max - min ) + min;
  }

  cat = {
    x: 50,
    y: 50,
    w: 90,
    h: 90,
    vx: 4,
    vy: 2,
    active: false,
    xMargin: 200,
    yMargin: 100,

    spawn() {
      this.x = range( this.xMargin, W - this.xMargin );
      this.y = range( this.yMargin, H - this.yMargin );
      this.vx = 4;
      this.vy = 2;
      this.active = true;

      let boundRight = this.x + this.w;
      let boundTop = this.y;

      // if on right side of board
      if ( boundRight > W / 2 ) {
        this.vx = -this.vx;
      }

      // if on bottom half of board
      if ( boundTop > H / 2 ) {
        this.vy = -this.vy;
      }
    },

    render() {
      if ( !this.active ) {
        this.spawn();
      }
      ctx.drawImage( catImg, this.x, this.y, this.w, this.h );
    },

    move() {
      this.x += this.vx;
      this.y += this.vy;
      let boundTop = this.y;
      let boundBottom = this.y + this.h;
      let boundLeft = this.x;
      let boundRight = this.x + this.w;
      let boundOffset = this.h / 2;

      // reverse direction when hitting vertical boundaries
      if ( boundBottom >= H ) {
        this.y = H - this.h;
        this.vy = -this.vy;
      } else if ( boundTop <= 0 ) {
        this.y = 0;
        this.vy = -this.vy;
      }

      // reset when exceeding horizontal boundaries
      if ( boundRight < 0 || boundLeft > W ) {
        this.active = false;
        catImg = sadCat;
        clearTimeout( timeout );
        timeout = setTimeout( () => {
          catImg = happyCat;
        }, 3000 );
      }

      // if on right side of board
      if ( boundRight > W / 2 ) {
        let paddle = paddles[ 1 ];
        let padTop = paddle.y;
        let padBottom = paddle.y + paddle.h;
        let padLeft = W - paddle.w;

        if (
          boundTop >= padTop - boundOffset
          && boundBottom <= padBottom + boundOffset
          && boundRight >= padLeft
        ) {
          if ( this.vx >= 0 ) {
            this.vx += 1;
            this.vy += .25;
            this.vx = -this.vx;
          }
        }
      } else {
        let paddle = paddles[ 0 ];
        let padTop = paddle.y;
        let padBottom = paddle.y + paddle.h;
        let padRight = paddle.w;
        if (
          boundTop > padTop - boundOffset
          && boundBottom <= padBottom + boundOffset
          && boundLeft <= padRight
        ) {
          if ( this.vx < 0 ) {
            this.vx = -this.vx;
          }
        }
      }
    }
  };


  // draw everything on canvas
  function draw() {
    clearCanvas();
    paintCanvas();
    paddles.forEach( ( paddle ) => {
      ctx.fillStyle = foregroundColor;
      ctx.fillRect( paddle.x, paddle.y, paddle.w, paddle.h );
    });

    cat.render();
    update();
  }

  function update() {
    // move paddles on mouse move
    if ( mouse.x && mouse.y ) {
      paddles.forEach( p => {
        if ( mouse.y <= p.h / 2 ) {
          p.y = 0;
          return;
        }
        if ( mouse.y >= H - p.h / 2 ) {
          p.y = H - p.h;
          return;
        }
        p.y = mouse.y - p.h / 2;
      });
    }

    // move cat
    cat.move();

    // keep on looping on
    if ( started ) {
      rAF( draw );
    }
  }

  // track mouse cursor position
  function trackPosition( e ) {
    mouse.x = e.clientX;
    mouse.y = e.pageY - containerOffset;
  }

  // add mouse event to canvas
  canvas.addEventListener( 'mousemove', trackPosition, true );

  window.addEventListener( 'scroll', () => {
    rAF( updateCoords );
  });

  window.addEventListener( 'resize', debounce( () => {
    if ( isMobile() ) {
      started = false;
      canvas.style.opacity = 0;
      return;
    }
    canvas.style.opacity = 1;
    rAF( updateCoords );
    calcCanvas();
    resetPaddles();
    if ( !started ) {
      rAF( draw );
    }
    started = true;
  }, 200 ) );

  function init() {
    if ( isMobile() ) {
      return;
    }
    calcCanvas();
    initPaddles();
    rAF( draw );
    started = true;
  }

  init();

});


export default undefined;
